import React from 'react'
import { Layout, Header, Hero, Services, Info, Seo } from '../components'

const AboutPage = () => {
  return (
    <Layout>
      <Seo
        title="About Page"
        description="The Great Dev Co. is a web design and development agency specializing in building Jamstack websites "
      />
      <Header text="We design and develop beautiful web apps" />
      <Hero />
      <Services />
      <Info />
    </Layout>
  )
}

export default AboutPage
